<template>
  <span 
    :class="[
      'text-capitalize', 
      'badge', 
      'bg-light', 
      'border', 
      'rounded-pill',
      statusColor
    ]">{{ status }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusColor() {
      const colors = {
        draft: 'text-info',
        approved: 'text-primary',
        processing: 'text-success',
        dispatched: 'text-warning',
        delivered: 'text-success',
        cancelled: 'text-danger',
        rejected: 'text-danger'
      };
      return colors[this.status] || '';
    }
  }
};
</script>